import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_INVENTORY_QUERY_KEY } from '~/features/hooks/useGetInventory'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { InventoryV2 } from '~/supabase/types'

export const useImportInventory = () => {
  const queryClient = useQueryClient()

  const { mutate: notifyError } = useNotifyError()

  return useMutation({
    mutationKey: ['import-models'],
    mutationFn: async (payload: Omit<InventoryV2, 'id' | 'created_at'>[]) => {
      const { data, error } = await supabaseApi.from('inventory_v2').insert(payload).select()

      if (error) {
        toast.error('Upload failed.')
        notifyError({
          message: 'Upload failed',
          data: { payload },
          error,
          function: 'useImportInventory',
        })
        throw error
      } else {
        toast.success('Upload successful')
        queryClient.invalidateQueries({ queryKey: [GET_INVENTORY_QUERY_KEY] })
        return data
      }
    },
  })
}
